import { Stack, Text, Title } from '@mantine/core';
import { Panel } from 'components/Panel';
import {
  hasCodaboxBankingAccounts,
  hasPontoBankingAccounts,
  useCompanyConfiguration,
} from 'init/use-company-configuration';
import { i18nKeys, useTranslation } from 'locales';
import type { FinancialData } from 'shared/hooks/use-load-dashboard';

import BankStatusAmount from './BankStatusAmount';

type Props = {
  data: FinancialData;
};

export default function BankStatus({ data }: Props) {
  const { t } = useTranslation();
  const company = useCompanyConfiguration();

  const { saldo, saldoOneWeek, saldoOneMonth } = data;
  const { currency } = company;

  return (
    <Panel h="100%" title={t(i18nKeys.DASHBOARD.BANK_STATUS.TITLE)}>
      <Stack>
        {(hasPontoBankingAccounts(company) || hasCodaboxBankingAccounts(company)) && (
          <Stack gap={0}>
            <Text c="dimmed">{t(i18nKeys.BANK_ACCOUNT_BALANCE)}</Text>
            <Title c="validation.7" order={5}>
              <BankStatusAmount data={saldo.total} currency={currency} />
            </Title>
          </Stack>
        )}
        <Stack gap="0">
          <Text c="dimmed">{t(i18nKeys.DASHBOARD.BANK_STATUS.WEEK_FORECAST)}</Text>
          <Title c="validation.7" order={5}>
            <BankStatusAmount data={saldoOneWeek} currency={currency} />
          </Title>
        </Stack>
        <Stack gap="0">
          <Text c="dimmed">{t(i18nKeys.DASHBOARD.BANK_STATUS.MONTH_FORECAST)}</Text>
          <Title c="validation.7" order={5}>
            <BankStatusAmount data={saldoOneMonth} currency={currency} />
          </Title>
        </Stack>
      </Stack>
    </Panel>
  );
}
